import { render, staticRenderFns } from "./AttachGpu.vue?vue&type=template&id=b115d97e&scoped=true"
import script from "./AttachGpu.vue?vue&type=script&lang=js"
export * from "./AttachGpu.vue?vue&type=script&lang=js"
import style0 from "./AttachGpu.vue?vue&type=style&index=0&id=b115d97e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b115d97e",
  null
  
)

export default component.exports